export const quantityBreakMessage = 'This product has a quantity break cost structure';
